// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-photo[data-v-75ef26ac]{width:40px;height:40px;-o-object-fit:cover;object-fit:cover}.title-card[data-v-75ef26ac]{font-size:20px}.text-card[data-v-75ef26ac],.title-card[data-v-75ef26ac]{color:#212529;font-family:Trebuchet MS,sans-serif}.text-card[data-v-75ef26ac]{font-size:12px}.text-autor[data-v-75ef26ac]{color:var(--global-01-primary,#007a4a);font-family:Trebuchet MS;font-size:13px;font-weight:700}", ""]);
// Exports
module.exports = exports;
